import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "ol/ol.css";

Vue.config.productionTip = false

import "@/assets/less/style.less";

import * as components from '@/components';
// Register global components functions
Object.keys(components).forEach(key => {
  Vue.component(key, components[key])
});


import { loadSettings } from './settings'

loadSettings().then(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
})